import React, {Suspense} from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";
import {MatchWidgetPlaceholder} from "./placeholders/match-widget.placeholder";

const MatchWidgetAsyncComponent = AsyncComponent(async () => import('./match-widget' /* webpackChunkName: "match-widget" */ ));

export const MatchWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper isMandatory>
    <Suspense fallback={<MatchWidgetPlaceholder />}>
      <MatchWidgetAsyncComponent {...props}/>
    </Suspense>
  </ErrorBoundaryWrapper>
};
